import React from 'react';

import PracticeBadge from '../PracticeBadge/PracticeBadge';
import GameBadge from '../GameBadge/GameBadge';
import ToolTip from '../../Tooltip/Tooltip';
import { GAME, PRACTICE } from '../../../../config/constants';
import { isCC } from '../../../../helpers';
import { EventDayPropsType } from './types';
import { useUserState } from '../../../../store/hooks';
import { ScheduleEvent } from '../../../../config/commonTypes';

import './styles.scss';

const EventDay = ({ events, isFirstWeek }: EventDayPropsType) => {
  const user = useUserState();
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const test = (event: ScheduleEvent) => 
    (event.type === GAME &&
      (event.homeTeamAbbr === user.teamShort || event.visitorTeamAbbr === user.teamShort));
  const eventsShow = [];
  const moreEvents = [];
  const badgeEvents:any = [];
  if(isMobile){
    if (events.every((event) => !test(event))) {
      eventsShow.push(...events.filter((event, index) => index < 3 && event.type !== GAME));
      moreEvents.push(...events.filter((event, index) => index >= 3 && event.type !== GAME));
    } else {
      const eventsOrdered = [...events.filter((event) => test(event)), ...events.filter((event) => !test(event))];
      eventsShow.push(...eventsOrdered.filter((event, index) => index < 3 && event.type !== GAME));
      moreEvents.push(...eventsOrdered.filter((event, index) => index >= 3 && event.type !== GAME));
    }
    eventsShow.forEach((event, index) =>{
        if(event.type === PRACTICE){
            badgeEvents.push(<PracticeBadge practice={event} key={index} />);
        }
    });
    if (badgeEvents.length === 0) {
      let count = 0;
      while (moreEvents.length > 0) {
        count++;
        if (moreEvents[0].type === PRACTICE) {
          badgeEvents.push(<PracticeBadge practice={moreEvents[0]} key={JSON.stringify(moreEvents[0])} />);
        }
      moreEvents.shift();
        if (count === 3) {
          break;
        }
      }
    }
  }else{
    if (events.every((event) => !test(event))) {
    eventsShow.push(...events.filter((event, index) => index < 3));
    moreEvents.push(...events.filter((event, index) => index >= 3));
  } else {
    const eventsOrdered = [...events.filter((event) => test(event)), ...events.filter((event) => !test(event))];
    eventsShow.push(...eventsOrdered.filter((event, index) => index < 3));
    moreEvents.push(...eventsOrdered.filter((event, index) => index >= 3));
  }
  eventsShow.forEach((event, index) => {
    if (event.type === GAME) {
      if (isCC(user)) {
        badgeEvents.push(<GameBadge game={event} key={index} />);
      } else if (event.homeTeamId === user.teamId || event.visitorTeamId === user.teamId) {
        badgeEvents.push(<GameBadge game={event} key={index} />);
      } else {
        moreEvents.push(event);
      }
    } else {
      badgeEvents.push(<PracticeBadge practice={event} key={index} />);
    }
  });
  if (badgeEvents.length === 0) {
    let count = 0;
    while (moreEvents.length > 0) {
      count++;
      if (moreEvents[0].type === GAME) {
        badgeEvents.push(<GameBadge game={moreEvents[0]} key={JSON.stringify(moreEvents[0])} />);
      } else {
        badgeEvents.push(<PracticeBadge practice={moreEvents[0]} key={JSON.stringify(moreEvents[0])} />);
      }
      moreEvents.shift();
      if (count === 3) {
        break;
      }
    }
  }
  }
  return (
    <>
      {badgeEvents}
      {moreEvents.length > 0 && (
        <ToolTip
          isFirstWeek={isFirstWeek}
          moreEvents={moreEvents}
          tooltipData
          margin
          // showToolTip={showToolTip}
          // setShowToolTip={setShowToolTip}
        />
      )}
    </>
  );
};

export default EventDay;